import {Fragment} from 'react'
import {Box} from '@chakra-ui/react'
import propTypes from 'prop-types'

import PrimaryStep from './PrimaryStep'
import PrimaryCurrentStep from './PrimaryCurrentStep'
import PrimaryProgressBar from './PrimaryProgressBar'

const nullStep = {number: 0, state: null, label: null}

const Primary = ({steps, currentState}) => {
  const stepsWithNumber = steps.map((step, index) => ({
    ...step,
    number: index + 1,
  }))

  const currentStep =
    stepsWithNumber.find((step) => step.state === currentState) || nullStep

  return (
    <>
      <Box display={{base: 'flex', md: 'none'}}>
        <PrimaryCurrentStep
          title={currentStep.label}
          icon={currentStep.icon}
          number={currentStep.number}
        />
      </Box>
      <Box
        display={{base: 'none', md: 'flex'}}
        alignItems="flex-end"
        flexWrap="wrap"
      >
        <PrimaryProgressBar isProgressed={currentStep.number >= 1} />
        {stepsWithNumber.map((step) => (
          <Fragment key={`${step.state}-${step.number}`}>
            <PrimaryStep
              title={step.label}
              icon={step.icon}
              number={step.number}
              isCurrentStep={step.number === currentStep.number}
              isPreviousStep={step.number < currentStep.number}
            />
            <PrimaryProgressBar
              isProgressed={step.number < currentStep.number}
            />
          </Fragment>
        ))}
      </Box>
    </>
  )
}

Primary.propTypes = {
  steps: propTypes.arrayOf(
    propTypes.shape({
      label: propTypes.string.isRequired,
      state: propTypes.string.isRequired,
      icon: propTypes.func,
    }),
  ).isRequired,
  currentState: propTypes.string.isRequired,
}

export default Primary
